import { XMPPClient } from '../types';
import { Logger } from '../utils';

// Armazena a referência global do cliente XMPP
let globalXMPPClient: XMPPClient | null = null;

// Função para definir o cliente global (chamada pelo GlobalConfigProvider)
export const setGlobalXMPPClient = (client: XMPPClient) => {
  globalXMPPClient = client;
};

export const getGlobalXMPPClient = () => {
  return globalXMPPClient;
};

/**
 * Limpa a referência do cliente XMPP global (sem desconectar)
 * Útil para permitir reconexão após navegação
 */
export const clearGlobalXMPPClient = () => {
  globalXMPPClient = null;
};

/**
 * Desconecta e limpa o cliente XMPP global
 * Deve ser chamado quando o usuário sai da sala/aplicação
 */
export const disconnectGlobalXMPPClient = async () => {
  if (globalXMPPClient) {
    try {
      Logger.info('XMPP', 'Desconectando cliente XMPP global...');
      await globalXMPPClient.stop();
      Logger.info('XMPP', 'Cliente XMPP global desconectado com sucesso');
    } catch (error) {
      Logger.error('XMPP', 'Erro ao desconectar cliente XMPP global:', error);
    } finally {
      globalXMPPClient = null;
    }
  }
};

/**
 * Verifica se o cliente XMPP global está conectado
 */
export const isGlobalXMPPConnected = (): boolean => {
  return globalXMPPClient?.status === 'online';
};

/**
 * Verifica se o cliente XMPP global existe mas está desconectado
 * Útil para detectar quando uma reconexão é necessária
 */
export const isGlobalXMPPDisconnected = (): boolean => {
  if (!globalXMPPClient) return true;
  return globalXMPPClient.status !== 'online';
};

// Hook que apenas retorna a instância global
export const useXMPP = () => {
  if (!globalXMPPClient) {
    Logger.warn('XMPP', 'Tentando usar useXMPP antes da inicialização global');
  }

  return {
    client: globalXMPPClient,
  };
};
